import _ from 'lodash';
import ah from '../utils/ajax-helper'; // get camera list

export var getDeviceCameras = function getDeviceCameras(contextRoot, noProgress, keyword, sort) {
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var external = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isAnalytic = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  var terminalId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      keyword: keyword,
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      external: external,
      isAnalytic: isAnalytic,
      terminalId: terminalId
    };
    ah.get("".concat(contextRoot, "/camera/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get camera list - Geographic

export var getDeviceCamerasgeographic = function getDeviceCamerasgeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/camera/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get camera streamUrls by using HLS

export var getCameraHLSStreamUrls = function getCameraHLSStreamUrls(contextRoot, noProgress, cameraId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/camera/").concat(cameraId, "/HLS"), null, null, noProgress).then(function (result) {
      if (result.code < 0) {
        throw new Error(result.error);
      }

      if (result.data && result.data.content && result.data.totalElements > 0) {
        return resolve(result.data.content.map(function (item) {
          return item.streamUrl;
        }));
      }

      return resolve([]);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create camera

export var createCameraAPI = function createCameraAPI(contextRoot, noProgress, cameraData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/create"), JSON.stringify(cameraData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit camera

export var editCameraAPI = function editCameraAPI(contextRoot, noProgress, cameraData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/edit"), JSON.stringify(cameraData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete multiple camera

export var deleteMultipleCameraAPI = function deleteMultipleCameraAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get event traffic
// export const getEventTraffic = (contextRoot, noProgress, sort, offset=0, limit=null) => {
//     return new Promise((resolve, reject) => {
//         let sortField = sort ? sort.field : 'source'
//         let sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc'
//         let requestParameters = { offset, limit, sort: sortField + ':' + sortOrder}
//         ah.get(`${contextRoot}/traffic/event/list`, requestParameters, null, noProgress)
//         .then(result => {
//             if(result.code < 0)
//                 throw new Error(result.error)
//             resolve(result.data)
//         }).catch(error => {
//             reject(error)
//         })
//     })
// }
// get event traffic - geographic

export var getEventTrafficGeographic = function getEventTrafficGeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/traffic/event/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get vds

export var getVds = function getVds(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var dataSource = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'updatedAt';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'desc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      dataSource: dataSource
    };
    ah.get("".concat(contextRoot, "/vd/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get vds - geographic

export var getVdsGeographic = function getVdsGeographic(contextRoot, noProgress, latLngStart, latLngEnd) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      longitude: "".concat(latLngStart.lng, ",").concat(latLngEnd.lng),
      latitude: "".concat(latLngStart.lat, ",").concat(latLngEnd.lat)
    };
    ah.get("".concat(contextRoot, "/vd/list/geographic"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // about camera va profile api --------

export var getCameraVaProfileList = function getCameraVaProfileList(contextRoot, noProgress, nvrIp) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/camera/va/profile/list"), {
      nvrIp: nvrIp
    }, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var createCameraVaProfileAPI = function createCameraVaProfileAPI(contextRoot, noProgress, nvrIp, data) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/va/profile/create?nvrIp=").concat(nvrIp), JSON.stringify(data), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var deleteCameraVaProfileAPI = function deleteCameraVaProfileAPI(contextRoot, noProgress, nvrIp, id) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/va/profile/delete?nvrIp=").concat(nvrIp), JSON.stringify({
      id: id
    }), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var setCameraVaProfileAPI = function setCameraVaProfileAPI(contextRoot, noProgress, nvrIp, data) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/va/profile/edit?nvrIp=").concat(nvrIp), JSON.stringify(data), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getCameraVaScheduleList = function getCameraVaScheduleList(contextRoot, noProgress, nvrIp, channel) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/camera/va/profile/schedule"), {
      nvrIp: nvrIp,
      channel: channel
    }, null, noProgress).then(function (result) {
      if (result.code < 0) return new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var setCameraVaScheduleAPI = function setCameraVaScheduleAPI(contextRoot, noProgress, nvrIp, channel, profileId, isScheduleOn) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/va/profile/schedule?nvrIp=").concat(nvrIp), JSON.stringify({
      channel: channel,
      profileId: profileId,
      isScheduleOn: isScheduleOn
    }), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getAiProcessorList = function getAiProcessorList(contextRoot, noProgress, nvrIp) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/camera/ai/processor/list"), {
      nvrIp: nvrIp
    }, null, noProgress).then(function (result) {
      if (result.code < 0) return new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // -----------------------------
// favorite camera list --------

export var getDeviceCamerasFavorite = function getDeviceCamerasFavorite(contextRoot, noProgress, sort) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/camera/favorite"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var addDeviceCamerasFavorite = function addDeviceCamerasFavorite(contextRoot, cameraId) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/camera/").concat(cameraId, "/favorite")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(cameraId);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var deleteDeviceCamerasFavorite = function deleteDeviceCamerasFavorite(contextRoot, cameraId) {
  return new Promise(function (resolve, reject) {
    ah.deleteRequest("".concat(contextRoot, "/camera/").concat(cameraId, "/favorite")).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(cameraId);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // --------
// tipc cctv

export var getTipcCctvList = function getTipcCctvList(contextRoot, noProgress, keyword, sort) {
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      keyword: keyword,
      offset: offset,
      limit: limit,
      sort: (sortField === 'name' ? 'id.name' : sortField) + ':' + sortOrder
    };
    ah.get("".concat(contextRoot, "/tipc-cctv/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // --------